module.exports = __webpack_public_path__ + "static/media/performance.a467f16c.png";